import { render } from "./index1.vue?vue&type=template&id=6d485582&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"

import "./index1.vue?vue&type=style&index=0&id=6d485582&lang=css"
import "./index1.vue?vue&type=style&index=1&id=6d485582&scoped=true&lang=css"
import "./index1.vue?vue&type=style&index=2&id=6d485582&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d485582"]])

export default __exports__